module.exports = __webpack_public_path__ + "img/实验室通风系统.aab0ce31.jpg";